/**
 * Decode HTML entities in text
 * Converts &amp; to &, &lt; to <, &gt; to >, &quot; to ", &#39; to ', etc.
 */
export function decodeHtmlEntities(text: string | null | undefined): string {
  if (!text) return ''
  
  const textArea = document.createElement('textarea')
  textArea.innerHTML = text
  return textArea.value
}

/**
 * Decode HTML entities in an object's string properties
 * Useful for decoding entire card objects from the database
 */
export function decodeCardData<T extends Record<string, any>>(obj: T): T {
  const decoded = { ...obj }
  
  for (const key in decoded) {
    if (typeof decoded[key] === 'string') {
      decoded[key] = decodeHtmlEntities(decoded[key]) as T[typeof key]
    }
  }
  
  return decoded
}